import { endsWith } from 'lodash';
import pluralize from 'pluralize';

function formatLabel(label) {
  // const startCased = startCase(label);
  const startCased = label;
  if (endsWith(startCased, ' Ids')) {
    return pluralize(startCased.replace(/ Ids$/, ''));
  } else if (endsWith(startCased, ' Id')) {
    return startCased.replace(/ Id$/, '');
  }
  return startCased;
}

export default formatLabel;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/formatLabel.js